import React from 'react'
import { SVGProps } from 'types/svg'
import COLORS from 'styles/colors'

const defaultSize = {
  width: 10,
  height: 10,
}

function Close({ style, color = COLORS.primaryDark }: SVGProps) {
  return (
    <svg style={{ ...defaultSize, ...style }} viewBox='0 0 9 8.999'>
      <path
        d='M5.491 4.5l3.365-3.365a.493.493 0 000-.7L8.561.144a.493.493 0 00-.7 0L4.5 3.509 1.135.144a.493.493 0 00-.7 0l-.3.295a.493.493 0 000 .7L3.509 4.5.144 7.865a.494.494 0 000 .7l.295.295a.493.493 0 00.7 0L4.5 5.491l3.365 3.365A.488.488 0 008.213 9a.488.488 0 00.348-.144l.295-.295a.494.494 0 000-.7z'
        fill={color}
      />
    </svg>
  )
}

export default Close
